import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    scrollY: 0,
    basicData: [],
    autoScale: true,
    permissionInfo: {}, //pc接口返回权限
    token: "",
    porjectInfo: {},
    pjcode: "", //移动端的
    userId: "999999999", //移动端的
    mobile: "", //移动端的
    month: "",
    pjname: "",
    spflag: "",
    gsname: "",
    gstel: "",
    zztoken: "",
    hasEvaluate: true,
    PublicMaintenance: true, // 公共区域维修
    baseData: {
      projectCode: "42010050",
      static: true,
      pjName: "武汉万科汉口传奇唐樾",
      companyName: "",
      year: "2024",
      month: "4",
      lastDay: "30",
      templateId: 2,
      chargingModeName: "",
      bandPic: "",
      tag:"万科物业",
      frequencyHiding:1
    },
    deviceData: {},
    systemMonitoringDetailsDate: "",
    likeReview: [
      {
        itemCode: "PROJECT",
        commentContent: null,
        clicked: false,
        clickTimes: 0,
        steped: false,
      },
      {
        itemCode: "FINANCE",
        commentContent: null,
        clicked: false,
        clickTimes: 0,
        steped: false,
      },
      {
        itemCode: "PROGRESS_MAJOR_ISSUES",
        commentContent: null,
        clicked: false,
        clickTimes: 0,
        steped: false,
      },
      {
        itemCode: "COMMUNITY_LIGHT_ACTION",
        commentContent: null,
        clicked: false,
        clickTimes: 0,
        steped: false,
      },
      {
        itemCode: "EMERGENCIES",
        commentContent: null,
        clicked: false,
        clickTimes: 0,
        steped: false,
      },
      {
        itemCode: "REPAIRS_COMMON_AREAS",
        commentContent: null,
        clicked: false,
        clickTimes: 0,
        steped: false,
      },
      {
        itemCode: "ROUTINE_MAINTENANCE",
        commentContent: null,
        clicked: false,
        clickTimes: 0,
        steped: false,
      },
      {
        itemCode: "QUALITY_SUPERVISION_MANAGEMENT",
        commentContent: null,
        clicked: false,
        clickTimes: 0,
        steped: false,
      },
      {
        itemCode: "FULL_SERVICE_FOR_CUSTOMERS",
        commentContent: null,
        clicked: false,
        clickTimes: 0,
        steped: false,
      },
      {
        itemCode: "SECURITY_GUARDS",
        commentContent: null,
        clicked: false,
        clickTimes: 0,
        steped: false,
      },
      {
        itemCode: "COMMUNITY_COGOVERNANCE",
        commentContent: null,
        clicked: false,
        clickTimes: 0,
        steped: false,
      },
    ],
    hasEvaluate: true,
    modalArrList: {
      wmShow: true, // 社文活动，文明宣传模块
      aqShow: true, // 安全模块
      postShow: true, //曝光台
      bwShow: false, // 重大事件
      LightupShow: false, // 点亮行动
      LightupShow1: false, // 点亮行动1
      LightupShow2: false, // 点亮行动2
      LightupShow3: false, // 点亮行动3
      culturalActivity: false,
      finance1: true, // 公共资源收益
      finance2: false, // 专项维修基金
      env: true,
      fireManagement: false,
      servicefee: true,
      emergency: true,
      passageway: true,
    },
    modal2edArrList: {
      BUILDING_PATROL: 1,
      ELV_MAINTAIN: 1,
      ELV_PATROL: 1,
      EMERGENCY: 1,
      EMERGENCYFACILITIES_MAINTAIN: 1,
      EMERGENCYFACILITIES_PATROL: 1,
      FIREFIGHTING_CHECK: 1,
      FIREFIGHTING_MAINTAIN: 1,
      FIREFIGHTING_MANAGER: 1,
      FIREFIGHTING_PATROL: 1,
      FITNESSANDLEISURE_MAINTAIN: 1,
      FITNESSANDLEISURE_PATROL: 1,
      LIFT_MAINTAIN: 1,
      LIFT_PATROL: 1,
      LIGHTING_MAINTAIN: 1,
      LIGHTING_PATROL: 1,
      NON_VEHICLE_CHARGING: 1,
      PASS_GEWAY: 1,
      PERIMETER_PATROL: 1,
      POWER_SUPPLY_DISTRIBUTION_MAINTAIN: 1,
      POWER_SUPPLY_DISTRIBUTION_PATROL: 1,
      PUBLICAREA_PATROL: 1,
      PUBLIC_EQUIPMENT_MAINTAIN: 1,
      SHOPS_PATROL: 1,
      SMART_MAINTAIN: 1,
      UNDERGROUNDPARKINGSPACES_PATROL: 1,
      UTILITY_MAINTAIN: 1,
      WATER_SUPPLY_DRAINAGE_MAINTAIN: 1,
      WATER_SUPPLY_DRAINAGE_PATROL: 1,
    },
  },
  mutations: {
    setAutoScale(state, info) {
      state.autoScale = info;
    },
    setProjectInfo(state, info) {
      state.porjectInfo = info;
    },
    setPermissionInfo(state, data) {
      state.permissionInfo = data;
    },
    setToken(state, data) {
      state.token = data;
    },

    setzztoken(state, data) {
      state.zztoken = data;
    },
    setpjcode(state, data) {
      state.pjcode = data;
    },
    setuserId(state, data) {
      state.userId = data;
    },
    setmobile(state, data) {
      state.mobile = data;
    },
    setspflag(state, data) {
      state.spflag = data;
    },
  },
  getters: {},
  actions: {},
  modules: {},
});
